import type { Branding } from './branding-client'

// Shared between Wizard (writer) and PublicLayout (reader). Wizard writes the
// resolved branding after fetch; reset to null for the generic (unslugged) flow.
export const brandStore = $state<{ current: Branding | null }>({ current: null })
